import React, { Component } from "react";
import { View, StyleSheet, Platform, ViewStyle, Image, ImageStyle, StyleProp } from "react-native";
import i18n from "@i18n/i18n";
import Currency from "@core/currencies/Currency";
import { colors } from "@styles/globalStyles";
import Icon from "@components/icons";
import { FiatCurrency } from "@core/fiat/FiatCurrency";
import Row from "@base/Row";
import CurrencyIcon from "./CurrencyIcon";
import RegularText from "@base/RegularText";

import { trimHelper } from "@utils/helpers/chat/chat.helper";
import SemiSemiBoldText, { SemiBoldText } from "@base/SemiBold";
import BoldText from "@base/BoldText";

interface Props {
    fiatCurrency?: FiatCurrency;
    currency?: Currency;
    balance?: number;
    amount?: string | number;
    style?: ViewStyle;
    iconSize?: number;
    fontSize?: number;
    fontWeight?: "regular" | "bold";
    fontColor?: string;
    trimLength?: number;
}

interface State {}

const { t } = i18n;

export default class CurrencyBalanceIcon extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <>
                {this.props.fiatCurrency && (
                    <Row style={this.props.style}>
                        <CurrencyIcon
                            currency={this.props.fiatCurrency}
                            size={this.props.iconSize || 14}
                        ></CurrencyIcon>
                        <RegularText
                            style={{ paddingRight: 1 }}
                            color={this.props.fontColor}
                            fontSize={this.props.fontSize || 12}
                        >
                            {" "}
                            {this.props.fiatCurrency.getSign()}
                        </RegularText>
                        {this.props.balance !== undefined && (
                            <>
                                {this.props.fontWeight == "regular" ? (
                                    <RegularText
                                        color={this.props.fontColor}
                                        align="center"
                                        fontSize={this.props.fontSize || 12}
                                        fixedWidth={150}
                                    >
                                        {this.props.fiatCurrency.fiatFormat(this.props.balance)}{" "}
                                    </RegularText>
                                ) : (
                                    <SemiBoldText
                                        color={this.props.fontColor}
                                        align="center"
                                        fontSize={this.props.fontSize || 12}
                                        fixedWidth={150}
                                    >
                                        {this.props.fiatCurrency.fiatFormat(this.props.balance)}{" "}
                                    </SemiBoldText>
                                )}
                            </>
                        )}

                        {this.props.amount !== undefined && (
                            <>
                                {this.props.fontWeight == "regular" ? (
                                    <RegularText
                                        color={this.props.fontColor}
                                        align="center"
                                        fontSize={this.props.fontSize || 12}
                                        fixedWidth={150}
                                    >
                                        {this.props.amount}
                                    </RegularText>
                                ) : (
                                    <SemiBoldText
                                        color={this.props.fontColor}
                                        align="center"
                                        fontSize={this.props.fontSize || 12}
                                        fixedWidth={150}
                                    >
                                        {this.props.amount}
                                    </SemiBoldText>
                                )}
                            </>
                        )}
                        <RegularText color={this.props.fontColor} fontSize={this.props.fontSize || 12}>
                            {" "}
                            {this.props.fiatCurrency.getSymbol()}
                        </RegularText>
                    </Row>
                )}

                {this.props.currency && (
                    <Row style={this.props.style}>
                        <CurrencyIcon currency={this.props.currency} size={this.props.iconSize || 14}></CurrencyIcon>
                        <RegularText color={this.props.fontColor} fontSize={this.props.fontSize || 12}>
                            {" "}
                        </RegularText>
                        {this.props.balance && (
                            <BoldText
                                color={this.props.fontColor}
                                align="center"
                                fontSize={this.props.fontSize || 12}
                                fixedWidth={150}
                            >
                                {this.props.fiatCurrency.fiatFormat(this.props.balance)}{" "}
                            </BoldText>
                        )}

                        <BoldText
                            color={this.props.fontColor}
                            align="center"
                            fontSize={this.props.fontSize || 12}
                            fixedWidth={150}
                        >
                            {trimHelper(this.props.amount.toString() || "", this.props.trimLength || 10)}
                        </BoldText>

                        <RegularText color={this.props.fontColor} fontSize={this.props.fontSize || 12}>
                            {" "}
                            {this.props.currency.getSymbol()}
                        </RegularText>
                    </Row>
                )}
            </>
        );
    }
}

const styles = StyleSheet.create({});
